import { PropsWithChildren } from "react";
import { getCookie } from "src/common/config/FunctionHelper";
import { paths, SEO_AFFILIATE_COOKIE_NAME } from "src/common/config/TextMessage";

interface GetAffiliateCodeProps extends PropsWithChildren {
}

const GetAffiliateCode = ({ children }: GetAffiliateCodeProps) => {
  const URLQueryParams = new URLSearchParams(window.location.search);
  const affiliateCode = URLQueryParams.get('red');


  // check if cookie already exists or not and URLQueryParams doesn't have the red query parameter
  // if exist, then delete that and redirect to site's domain
  const existingCookie = getCookie(SEO_AFFILIATE_COOKIE_NAME);
  if (!affiliateCode && existingCookie) {
    document.cookie = `${SEO_AFFILIATE_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`;

    window.location.href = `${window.location.origin}${paths.signup}?red=${existingCookie}`;
  }

  // set in global window object
  if (affiliateCode) {
    const expireDate = new Date();
    expireDate.setMonth(expireDate.getMonth() + 2);
    let hostName = window.location.host.split(`.`).slice(-2).join(`.`)

    if(hostName.includes('localhost')){
      hostName = 'localhost'
    }
    document.cookie = `${SEO_AFFILIATE_COOKIE_NAME}=${affiliateCode}; expires=${expireDate.toUTCString()}; path=/; domain=${hostName}`;
    
  }

  return <>{children}</>
}

export default GetAffiliateCode;